import {
    LEAD_APP_LINK_KEY,
    LeadAppLinkState, selectAllLeadAppLinks,
    selectLeadAppLinkEntities, selectLeadAppLinksFetched, selectLeadAppLinksLatestUpdatedAt,
} from '../../reducers/mdqx/lead-app-link.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';


const selectState = createFeatureSelector<LeadAppLinkState>(LEAD_APP_LINK_KEY);

export const getLeadAppLinkDictionary = createSelector(selectState, selectLeadAppLinkEntities);
export const getLeadAppLinks = createSelector(selectState, selectAllLeadAppLinks);
export const getLeadAppLinksFetched = createSelector(selectState, selectLeadAppLinksFetched);
export const getLeadAppLinkLatestUpdatedAt = createSelector(selectState, selectLeadAppLinksLatestUpdatedAt);


export const getLeadAppLinkById = (props: { id: number }) => createSelector(getLeadAppLinkDictionary, (dictionary) => props?.id && dictionary[props.id]);
